import $ from 'jquery';

export default (props, e) => {
	e.preventDefault();
	$(e.target).closest('.dropdown').toggleClass('opened');
};



// WEBPACK FOOTER //
// ./fe/web-uhkPoint/src/js/webActions/dropdownHandler.js